{
  "class": {
    "customer": "العملاء",
    "user": "المستخدمون",
    "project_time": "وقت المشاريع وملاحظاتها",
    "ai_conversation": "محادثات المساعد الذكي"
  },
  "trigger": {
    "ARCHIVED": "أرشفة السجل",
    "DEACTIVATED": "إيقاف الحساب"
  },
  "action": {
    "ANONYMISE": "إخفاء الهوية",
    "PURGE_FILES": "حذف الملفات المرفقة",
    "ANONYMISEHint": "تُحذف البيانات الشخصية ويبقى السجل ومستنداته.",
    "PURGE_FILESHint": "تُحذف الملفات المرفقة ويبقى السجل."
  },
  "rules": {
    "title": "قواعد الاحتفاظ",
    "body": "مدة الاحتفاظ بالبيانات الشخصية بعد أرشفة سجلها، وما يحدث لها بعد ذلك. لا يُمس أي سجل عليه حجز قانوني.",
    "moduleOff": "الوحدة متوقفة: الاحتفاظ يعمل",
    "moduleOffHint": "يستمر تطبيق الاحتفاظ حتى لو أوقفت الشركة الوحدة، فلا تُحفظ البيانات أطول من المسموح.",
    "later": "متاح في إصدار لاحق",
    "laterBody": "لا يمكن إخفاء هوية هذا النوع من السجلات بعد، لذا تبقى هذه القاعدة متوقفة.",
    "enabled": "إخفاء الهوية بعد انتهاء المدة من {{trigger}}",
    "period": "مدة الاحتفاظ",
    "floorHint": "{{n}} شهرًا على الأقل (الحد الأدنى النظامي).",
    "months": "شهرًا",
    "action": "بعدها",
    "onlyAction": "الإجراء الوحيد المسموح لهذا النوع من البيانات.",
    "offNote": "متوقفة: لا يُخفى شيء تلقائيًا، ويمكن الرد على طلبات الأشخاص.",
    "save": "حفظ قواعد الاحتفاظ",
    "saved": "حُفظت قواعد الاحتفاظ",
    "errors": {
      "belowFloor": "أدخل {{n}} شهرًا على الأقل، وهو الحد الأدنى النظامي لهذه البيانات.",
      "wholeNumber": "أدخل عددًا صحيحًا من الأشهر.",
      "tooLong": "أدخل {{max}} شهرًا على الأكثر."
    }
  },
  "runs": {
    "loading": "جارٍ التحميل…",
    "failed": "تعذّر تحميل آخر تشغيل.",
    "summary": "آخر تشغيل {{date}}: {{due}} مستحق، و{{queued}} في انتظار إخفاء الهوية، و{{held}} محفوظ بحجز قانوني.",
    "never": "لم يُشغَّل الاحتفاظ بعد، ويعمل كل ليلة."
  },
  "register": {
    "title": "سجل المعالجة",
    "body": "البيانات الشخصية التي تحتفظ بها الشركة، وسبب ذلك، وأقل مدة لحفظها.",
    "class": "البيانات",
    "basis": "الأساس النظامي",
    "floor": "تُحفظ على الأقل",
    "rule": "الاحتفاظ",
    "months": "{{n}} شهرًا",
    "on": "مفعّل، بعد {{n}} شهرًا",
    "off": "متوقف",
    "failed": "تعذّر تحميل السجل."
  },
  "holds": {
    "title": "الحجز القانوني",
    "settingsBody": "أبقِ السجل خارج الاحتفاظ ما دام هناك نزاع أو تدقيق أو مطالبة قائمة.",
    "place": "وضع حجز",
    "views": "عروض الحجز",
    "active": "قائم",
    "lifted": "مرفوع",
    "empty": {
      "title": "لا توجد سجلات محجوزة",
      "body": "ضع حجزًا لمنع إخفاء هوية سجل ما دام هناك نزاع أو تدقيق قائم.",
      "lifted": "لم يُرفع أي حجز بعد"
    },
    "placedBy": "وُضع في {{date}} بواسطة {{name}}",
    "placedOn": "وُضع في {{date}}",
    "liftedBy": "رُفع في {{date}} بواسطة {{name}}",
    "liftedOn": "رُفع في {{date}}",
    "lift": "رفع",
    "liftNamed": "رفع الحجز عن {{name}}",
    "counter": "{{n}} من {{max}} حرفًا.",
    "reason": "السبب",
    "reasonHint": "اذكر سبب الحجز، مثل القضية أو التدقيق.",
    "placeTitle": "وضع حجز قانوني",
    "placeBody": "ما دام الحجز قائمًا، لا تُخفى هوية السجل أبدًا، لا بالاحتفاظ ولا بطلب.",
    "placed": "حُجز {{name}}",
    "liftTitle": "رفع الحجز عن {{name}}؟",
    "liftBody": "يعود تطبيق الاحتفاظ على السجل. لا يُعاد حجز مرفوع، بل يوضع حجز جديد عند الحاجة.",
    "liftReason": "سبب رفع الحجز",
    "liftReasonHint": "يُحفظ في سجل التدقيق.",
    "liftedToast": "رُفع الحجز عن {{name}}",
    "errors": {
      "subject": "اختر السجل المراد حجزه.",
      "reason": "اكتب {{n}} أحرف على الأقل.",
      "already": "هذا السجل محجوز بالفعل.",
      "unknown": "هذا السجل لم يعد موجودًا أو أُخفيت هويته.",
      "alreadyLifted": "رُفع هذا الحجز من قبل. حدّث الصفحة لرؤيته."
    }
  },
  "subject": {
    "type": "نوع السجل",
    "customer": "عميل",
    "user": "مستخدم",
    "pickCustomer": "ابحث بالاسم أو الرمز أو الجوال",
    "customerHint": "يشمل العملاء المؤرشفين.",
    "userHint": "المستخدمون النشطون في الشركة.",
    "removed": "سجل محذوف",
    "notYet": "لم يُتحقق بعد"
  },
  "clock": {
    "dayOf": "اليوم {{day}} من {{total}}",
    "closedOn": "أُغلق في {{date}}",
    "closed": "مغلق",
    "overdue_zero": "متأخر",
    "overdue_one": "متأخر يومًا واحدًا",
    "overdue_two": "متأخر يومين",
    "overdue_few": "متأخر {{n}} أيام",
    "overdue_many": "متأخر {{n}} يومًا",
    "overdue_other": "متأخر {{n}} يوم",
    "wasDue": "كان مستحقًا في {{date}}",
    "dueToday": "مستحق اليوم",
    "dueIn_zero": "مستحق اليوم",
    "dueIn_one": "مستحق بعد يوم واحد",
    "dueIn_two": "مستحق بعد يومين",
    "dueIn_few": "مستحق بعد {{n}} أيام",
    "dueIn_many": "مستحق بعد {{n}} يومًا",
    "dueIn_other": "مستحق بعد {{n}} يوم",
    "due": "يُستحق في {{date}}",
    "answerBy": "الرد قبل {{date}}",
    "rule": "يمنح النظام 45 يومًا تقويميًا من يوم استلام الطلب، ويُحسب يوم الاستلام اليوم الأول."
  },
  "status": {
    "RECEIVED": "مستلم",
    "VERIFIED": "متحقق منه",
    "IN_PROGRESS": "قيد المعالجة",
    "COMPLETED": "مكتمل",
    "REFUSED": "مرفوض"
  },
  "kind": {
    "ACCESS": "الاطلاع على البيانات",
    "CORRECTION": "تصحيح",
    "ERASURE": "حذف",
    "OBJECTION": "الاعتراض على المعالجة",
    "PORTABILITY": "نسخة لنقلها",
    "CONSENT_WITHDRAWAL": "سحب الموافقة"
  },
  "channel": {
    "EMAIL": "البريد الإلكتروني",
    "LETTER": "خطاب",
    "IN_PERSON": "حضوريًا",
    "PHONE": "الهاتف",
    "OTHER": "أخرى"
  },
  "fields": {
    "requester": "مقدّم الطلب",
    "requesterName": "اسم مقدّم الطلب",
    "requesterContact": "وسيلة التواصل معه",
    "kind": "الطلب",
    "channel": "وصل عبر",
    "receivedOn": "تاريخ الاستلام",
    "dueOn": "الرد قبل",
    "clock": "الوقت المتبقي",
    "status": "الحالة",
    "assignee": "المسؤول",
    "unassigned": "غير مسند",
    "subject": "صاحب البيانات",
    "details": "التفاصيل"
  },
  "queue": {
    "title": "طلبات الخصوصية",
    "intro": "طلبات الأشخاص بشأن بياناتهم الشخصية. يجب الرد على كل طلب خلال 45 يومًا تقويميًا.",
    "log": "تسجيل طلب",
    "views": "عروض الطلبات",
    "view": {
      "open": "مفتوحة",
      "dueSoon": "مستحقة خلال 7 أيام",
      "overdue": "متأخرة",
      "closed": "مغلقة"
    },
    "searchPlaceholder": "ابحث باسم مقدّم الطلب",
    "searchLabel": "البحث في الطلبات",
    "clearSearch": "مسح البحث",
    "clearFilters": "مسح عوامل التصفية",
    "allKinds": "كل الطلبات",
    "tableLabel": "طلبات الخصوصية",
    "empty": {
      "filtered": "لا توجد طلبات مطابقة",
      "open": "لا توجد طلبات مفتوحة",
      "openBody": "عندما يسأل شخص عن بياناته الشخصية بالبريد أو بخطاب أو بالهاتف أو حضوريًا، سجّل طلبه هنا ليبدأ عدّ الـ45 يومًا.",
      "dueSoon": "لا شيء مستحق خلال الأيام السبعة القادمة",
      "overdue": "لا يوجد طلب متأخر",
      "closed": "لم يُغلق أي طلب بعد"
    }
  },
  "log": {
    "title": "تسجيل طلب خصوصية",
    "body": "سجّل الطلب كما وصل إلى الشركة. يبدأ عدّ الـ45 يومًا من يوم استلامه.",
    "submit": "تسجيل الطلب",
    "kindHint": "ما يطلبه الشخص.",
    "contactHint": "بريد إلكتروني أو رقم هاتف أو عنوان بريدي.",
    "receivedHint": "اختر تاريخًا سابقًا إن وصل قبل اليوم، ولا يجوز تاريخ في المستقبل.",
    "dueHint": "يجب الرد قبل {{date}}.",
    "detailsHint": "اختياري: ما قاله، والمراجع، والمستندات التي اطّلعت عليها.",
    "logged": "سُجّل طلب {{name}}",
    "errors": {
      "future": "لا يجوز أن يكون تاريخ الاستلام في المستقبل."
    }
  },
  "actions": {
    "verify": "تحقق",
    "start": "بدء العمل",
    "complete": "إكمال",
    "refuse": "رفض",
    "export": "تصدير البيانات (JSON)",
    "exporting": "جارٍ التصدير…",
    "exportNeedsSubject": "تحقق أولًا من صاحب البيانات."
  },
  "detail": {
    "request": "الطلب",
    "refusedTitle": "مرفوض",
    "exported": "صُدّرت البيانات",
    "conflict": {
      "title": "غيّر شخص آخر هذا الطلب",
      "body": "أعد التحميل لترى حالته الآن، ثم حاول مرة أخرى.",
      "reload": "إعادة التحميل"
    },
    "held": {
      "title": "السجل عليه حجز قانوني",
      "body": "لا يمكن حذفه ما دام الحجز قائمًا. ارفع الحجز، أو ارفض الطلب مع ذكر السبب.",
      "link": "فتح الحجز القانوني"
    },
    "referenced": {
      "title": "رُفض الطلب",
      "body": "ما زالت مستندات صادرة تشير إلى هذا السجل، لذا يُحفظ للسجلات القانونية والضريبية. سُجّل السبب."
    }
  },
  "verify": {
    "title": "التحقق من الطلب",
    "body": "تأكد من هوية الشخص واختر السجل الذي يحمل بياناته.",
    "pickSubject": "اختر صاحب البيانات."
  },
  "start": {
    "title": "بدء العمل على هذا الطلب؟",
    "body": "ينتقل الطلب إلى قيد المعالجة، ويستمر العدّ."
  },
  "complete": {
    "title": "إكمال هذا الطلب؟",
    "body": "تأكد أن الشخص تلقّى الرد. لا يمكن تغيير طلب مكتمل.",
    "erasureBody": "ستُحذف البيانات الشخصية للسجل نهائيًا، وسيظهر سجله التاريخي بقيم محجوبة. لا يمكن التراجع عن ذلك.",
    "erasureConfirm": "حذف وإكمال"
  },
  "refuse": {
    "title": "رفض هذا الطلب؟",
    "body": "أخبر مقدّم الطلب بالسبب. لا يمكن إعادة فتح طلب مرفوض.",
    "reason": "سبب الرفض",
    "needReason": "اكتب السبب الذي سيُبلَّغ به مقدّم الطلب.",
    "counter": "{{n}} من {{max}} حرفًا."
  },
  "toast": {
    "verified": "تم التحقق من الطلب",
    "started": "بدأ العمل",
    "completed": "اكتمل الطلب",
    "refused": "رُفض الطلب"
  },
  "timeline": {
    "title": "المسار الزمني",
    "empty": "لم يحدث شيء بعد.",
    "system": "النظام",
    "event": {
      "RECEIVED": "سجّل {{actor}} الطلب",
      "VERIFIED": "تحقق {{actor}} من مقدّم الطلب والسجل",
      "IN_PROGRESS": "بدأ {{actor}} العمل",
      "COMPLETED": "أكمل {{actor}} الطلب",
      "REFUSED": "رفض {{actor}} الطلب"
    }
  }
}
